<template>
  <div class="container">
    <el-card>
      <div slot="header" class="clearfix">
        <el-row type="flex" justify="space-between">
          <el-col :span="14">
            <el-popover
              v-if="!showEdit"
              placement="bottom"
              width="auto"
              trigger="hover"
              >
              <div> {{ data.ware_name}} </div>
              <div class="text-wrapper" slot="reference">{{ data.ware_name }} </div>
            </el-popover>
          </el-col>
          <el-col :span="10">
            <div> {{ data.insure_time }} </div>
          </el-col>
        </el-row>
        <!-- <el-button v-if="showEdit" style="float: right; padding: 3px 0" type="text" @click="handleSave">保存</el-button> -->
        <!-- <el-button v-else style="float: right; padding: 3px 0" type="text" @click="handleEdit">编辑</el-button> -->
      </div>
      
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="85px" label-position="left">
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">

          <el-form-item v-if="showEdit" prop="insure_time" label="投保时间：">
            <el-date-picker
              v-if="showEdit"
              v-model="editForm.insure_time"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width:85px"
              size="small"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
            <div style="width:150px" v-else> <strong> {{ data.insure_time }} </strong> </div>
          </el-form-item>

          <el-form-item prop="applicant_name" label="投保人：" >
            <el-input size="small" v-if="showEdit" v-model="editForm.applicant_name" style="width:170px" /> 
            <div style="width:85px" v-else><strong> {{ data.applicant_name }} </strong> </div>
          </el-form-item>

          <el-form-item prop="insurant_name" label="被保险人：">
            <el-input size="small" v-if="showEdit" v-model="editForm.insurant_name" style="width:170px" /> 
            <div style="width:85px" v-else><strong> {{ data.insurant_name }} </strong> </div>
          </el-form-item>
          
          <el-form-item prop="premium" label="保费：">
            <el-input size="small" v-if="showEdit" v-model="editForm.premium" style="width:170px" />
            <div style="width:85px" v-else> <strong>{{ data.premium | formatAmount }} </strong></div>
          </el-form-item>
          
          <el-form-item prop="status" label="状态：">
            <el-select v-if="showEdit" v-model="editForm.status" placeholder="请选择" size="small" style="width:170px">
              <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
              </el-option>
            </el-select>
            <div style="width:85px" v-else> <strong>{{ data.status | formatStatusName }} </strong></div>
          </el-form-item>

        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  const initStatusList = [
    { value: 0, label: '空' },
    { value: 10000, label: '核保' },
    { value: 10100, label: '核保成功' },
    { value: 91000, label: '核保失败' },
    { value: 12000, label: '支付' },
    { value: 12100, label: '待支付' },
    { value: 12200, label: '支付成功' },
    { value: 91200, label: '待支付过期' },
    { value: 13000, label: '出单' },
    { value: 13100, label: '出单完成' },
    { value: 13150, label: '基础数据同步完成' },
    { value: 13200, label: '同步完成' },
    { value: 91320, label: '同步失败' },
    { value: 91300, label: '出单失败' },
    { value: 14000, label: '保单生效' },
    { value: 15000, label: '犹豫期内' },
    { value: 91500, label: '犹退' },
    { value: 15100, label: '犹豫期后' },
    { value: 17000, label: '保障中' },
    { value: 91700, label: '犹豫期后退保' },
    { value: 18000, label: '保单结束' },
    { value: 91800, label: '保障期满' },
    { value: 91810, label: '保障中止' },
    { value: 91820, label: '保障终止' }
  ],
  initRules = {

  }
  export default {
    name: 'CustomOrderItem',
    components: {  },
    props: {
      data: {
        type: Object,
        default: function () {
          return {
            id: null,
            applicant_name: null,
            insurant_name: null,
            insure_time: null,
            premium: null,
            status: null,
            ware_name: null
          }
        }
      },
      showEdit: {
        type: Boolean,
        default: false
      },
      index: {
        type: Number,
        default: 0
      }
    },
    filters: {
      formatAmount(amount) {
        return amount ? amount / 100 + ' 元' : amount + ' 元'
      },
      formatStatusName(key) {
        let status = initStatusList.find(i => i.value === key)
        return status ? status.label : ''
      }
    },
    data () {
      return {
        editForm: { ...this.data.data },
        showEditForm: false,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() >= Date.now();
          }
        }
      }
    },
    computed: {
      editRules: function () {
          return { ...initRules }
      }
    },
    created() {

    },
    methods: {
      handleEdit() {
        this.$emit('change-show', true, this.index)
      },
      handleSave() {
        this.$refs.editForm.validate(async valid => {
          if (valid) {
            if (this.data.id && this.data.role) {
              this.$emit('change-update', {id: this.data.id, role: this.editForm.role, data: this.editForm}, this.index)
            } else {
              this.$emit('change-save',  this.editForm.role, this.editForm, this.index)
            }
          }
        })
      },
      handleEditFormDialogClose() {
        this.$refs.editForm.clearValidate()
      }
    }
  }
</script>
<style scoped>
.container {
  margin: 5px 0;
}
.el-form-item {
  margin-bottom: 1px;
  margin-right: 10px;
}
.is-error {
  margin-bottom: 15px;
}

.text-wrapper {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}
.el-form {
  display: flex;
  flex-flow: row wrap;
}
.health-item {
  border-radius: 2px;
  border: 1px solid #ddd6d6;
  padding: 2px 5px;
  margin-bottom: 5px;
}
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
/deep/ input[type='number'] {
  -moz-appearance: textfield !important;
}

</style>